module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/bookmark-b3259dc6096b79a6d51559187d0f39ff.svg";